module.exports = __webpack_public_path__ + "static/media/qrcode.e9d43a9a.png";